import React from 'react';

import { createRoot } from 'react-dom/client';
import AppProvider from 'providers/AppProvider';
import { Provider as ReduxProvider} from 'react-redux';
import { store } from './features-csvc/reduxStore/store';

import { SetUpCurrentUserInRedux } from './features-csvc/reduxStore/SetUpCurrentUserInRedux';
import EntranceProvider from 'providers/EntranceProvider';
//import { RouterProvider } from 'react-router-dom';
//import { router } from 'routes';
import { CsvcRouterProvider } from './features-csvc/routes/CsvcRouterProvider';
import 'helpers/initFA';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

//  INIZIO Import Aggiunti da AA per autenticazione con msal
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./authConfig.js";
import { MsalLoginLinkPage } from "aaMsal/MsalLoginLinkPage.jsx";
// import AaLoginLayout from 'aaLayouts/AaLoginLayout.js';
// import AaPageLayout from 'aaLayouts/AaPageLayout.jsx';
//  FINE Import Aggiunti da AA per autenticazione con msal

//  INIZIO Codice Aggiunto da AA per autenticazione con msal
/**
* MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
* For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
*/


const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

let jwtToken = null    
msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
      event.payload.account
  ) {
    const activeAccount = event.payload.account;
    msalInstance.setActiveAccount(activeAccount);
    jwtToken = activeAccount.idToken
    //console.log('in index.js - jwtToken: ', jwtToken)
  }
  /*
  // 2025-03-13 INIZIO codice aggiunto per gestire RESET PASSWORD
  else if (event.eventType === EventType.LOGIN_FAILURE){
    if (event.error.errorMessage.includes("AADB2C90118")) { // The user has forgotten their password.
      console.log('in index.js - redirect to B2C_1_RESET () ')
      const authority = "https://csvcpm.b2clogin.com/crowdalert.onmicrosoft.com/B2C_1_RESET";
      console.log(`in index.js - redirect to B2C_1_RESET (${authority}) `)
      event.loginRedirect({authority: authority})
    }
  }
  // 2025-03-13 FINE codice aggiunto per gestire RESET PASSWORD
  */
});
console.log('*** Avvio index.js ***')

//  FINE Codice Aggiunto da AA per autenticazione con msal

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>
        <AppProvider>
          <ReduxProvider store={store}>
            <SetUpCurrentUserInRedux />
            <CsvcRouterProvider jwtToken={jwtToken}/>
          </ReduxProvider>
        </AppProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <EntranceProvider>
          <MsalLoginLinkPage />
        </EntranceProvider>
      </UnauthenticatedTemplate>
    </MsalProvider>
  </React.StrictMode>
);

/*
//  Render ORIGINALE senza Msal (senza autenticazione)
root.render(
  <React.StrictMode>
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  </React.StrictMode>
);*/